import { SECTION_STATE_ACTION } from '../../../features/analyses/Freeform/FreeformAnalysisForm/FreeformAnalysisFormUtil/sectionsReducer';

export const setNonLaidOutLibraryItems = (items, dispatch) => {
  dispatch({
    type: SECTION_STATE_ACTION.UPDATE_NON_LAID_OUT_LIBRARY_ITEMS,
    payload: {
      items,
    },
  });
};

export const setCurrentSections = (sections, dispatch) => {
  dispatch({
    type: SECTION_STATE_ACTION.UPDATE_SECTIONS,
    payload: sections,
  });
};

export const setSectionToScroll = (sectionId, dispatch) => {
  dispatch({
    type: SECTION_STATE_ACTION.SECTION_TO_SCROLL,
    payload: sectionId,
  });
};

export const setAddLibraryLocation = (droppable, dispatch) => {
  dispatch({
    type: SECTION_STATE_ACTION.ITEM_TO_ADD,
    payload: droppable,
  });
};

export const clearAddLibraryLocation = (dispatch) => {
  dispatch({
    type: SECTION_STATE_ACTION.ITEM_TO_ADD_CLEAR,
  });
};
